import React from 'react';
import { DonutLegendChart } from '@/components/ui/DonutLegendChart';

export function ProjectEquipmentStats() {
  const statsData = [
    { name: 'Đang sử dụng', value: 28, color: '#10b981' },
    { name: 'Bảo dưỡng định kỳ', value: 6, color: '#f59e0b' },
    { name: 'Đang sửa chữa', value: 3, color: '#f43f5e' },
    { name: 'Chờ sử dụng', value: 11, color: '#94a3b8' },
  ];

  return (
    <DonutLegendChart
      title="Thống kê thiết bị"
      centerValue={48}
      centerLabel="Tổng thiết bị"
      data={statsData}
      total={48}
    />
  );
}
